export default {
  Reserve: 1, 
  Resource: 2,
  Inferred: 3,
  PotentialMineral: 4
};